module.exports = __webpack_public_path__ + "img/arrow-up-right.47c86992.svg";